import { render, staticRenderFns } from "./MaxPriceLabel.vue?vue&type=template&id=d7b47ad4&scoped=true"
import script from "./MaxPriceLabel.vue?vue&type=script&lang=js"
export * from "./MaxPriceLabel.vue?vue&type=script&lang=js"
import style0 from "./MaxPriceLabel.vue?vue&type=style&index=0&id=d7b47ad4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b47ad4",
  null
  
)

export default component.exports